<template>
  <modal height="auto" :scrollable="true" adaptive name="deploy-app-modal" @before-open="beforeOpen">
    <header class="modal__header">
      <template>
        Deploy App
      </template>
      <i class="fas fa-times" @click="$modal.hide('deploy-app-modal')"></i>
    </header>
    <main class="modal__body">
      <div class="sync__project-details">
        <div>
          <div class="sync-project__login">
            <div class="sync-form__row">
              <rum-label for="name">PROJECT URL</rum-label>
              <div class="sync-auth">
                <rum-input class="sync-auth__id" :value="projectUrl" readonly />
                <div class="sync-action__container">
                  <rum-label class="sync-auth__label"><a class="project-url" target="_blank" :href="projectUrl"><img src="@/assets/images/eye.svg" class="eye__image" />View</a></rum-label>
                  <rum-label class="sync-auth__label" @click.native="copyText(projectUrl)"><i class="far fa-copy server-action__item"></i>Copy</rum-label>
                </div>
              </div>
            </div>
          </div>
          <div class="qrcode__container">
            <div class="qrcode__button">
              <rum-button secondary @click="downloadQR">Download QR Code</rum-button>
              <rum-button secondary @click="printQR" class="qrcode__print">Print</rum-button>
            </div>
          </div>
        </div>
        <div class="qrcode-container__code">
          <a href="#" onclick="this.href = this.getElementsByTagName('img')[0].src;" :download="downloadQRImageName">
            <rum-qr-code id="qr-code"  :text="this.validFormatForQR" :size="150" color="#000" bg-color="#FFF" error-level="L"/>
          </a>
        </div>
      </div>
    </main>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      project: {},
    }
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    downloadQRImageName() {
      return `project_${this.projectId}_qrcode`
    },
    validFormatForQR() {
      return this.projectUrl;
    },
    projectUrl() {
      return `${this.$store.getters['projectEdit/projectUrl']}${this.projectEncodedId}`;
    },
    projectName() {
      return this.$store.state.projectEdit.currentProjectName;
    },
    projectEncodedId() {
      return this.project && this.project.encodedID;
    }
  },
  methods: {
    beforeOpen(event) {
      this.project = event.params.project;
    },
    copyText(text) {
      this.$copyToClipboard(text);
      this.$notify({
        type: "success",
        title: "The link was copied to clipboard."
      });
    },
    downloadQR() {
      const element = document.getElementById("qr-code");
      element.click();
    },
    printQR() {
      const element = document.getElementById("qr-code").innerHTML;
      var printWindow = window.open('', '', 'height=800,width=800');
      printWindow.document.write(element);
      printWindow.document.close();
      const title = printWindow.document.title = `Project - ${this.projectName} - QR Code`;
      const heading = printWindow.document.createElement('h1');
      const text = printWindow.document.createTextNode(title);
      heading.appendChild(text);
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '@page { size: auto;  margin: 0mm; }';
      heading.setAttribute('style', 'order: -1; margin-bottom: 50px;');
      printWindow.document.body.appendChild(heading);
      printWindow.document.body.appendChild(style);
      printWindow.document.body.setAttribute('style', 'display: grid; width: 100%; justify-items: center; margin: 0;');
      printWindow.print();
    },
  }
};
</script>

<style scoped>
.modal__body {
  padding-bottom: var(--spacing-8);
}
.modal-body__label {
  padding-top: var(--spacing-4);
}

.modal-body__checkbox {
  padding-top: var(--spacing-2);
}

.modal-body__icon {
  margin-top: var(--spacing-8);
}

.modal-footer__action {
  display: flex;
  justify-content: space-between;
}

.modal-footer__button {
  margin-bottom: var(--spacing-3);
}

.sync__project-details {
  display: flex;
}

.sync__project-details > div {
  margin-right: var(--spacing-4);
}

.sync-action__container {
  display: flex;
  margin-top: var(--spacing-4);
}

.sync-auth__label {
  margin-right: var(--spacing-6);
  cursor: pointer;
}

.far {
  margin-right: var(--spacing-2);
}

.project-url {
  text-decoration: none;
  color: var(--primary);
}

.sync-form__row {
  margin-top: var(--spacing-6);
  margin-left: calc(-1 * var(--spacing-4));
  padding-left: var(--spacing-4);
}

.sync-container__config {
  padding-bottom: var(--spacing-8);
}

.sync-form__border {
  border-bottom: var(--border-2) solid var(--grey-lighter);
  margin: var(--spacing-6) calc(-1 * var(--spacing-4));
}

.sync-form__auth {
  padding: var(--spacing-4);
  margin: var(--spacing-4);
  background-color: var(--white);
}

.qrcode__container {
  display: flex;
  margin-top: var(--spacing-4);
}

.qrcode__print {
  margin-left: var(--spacing-12);
}

.qrcode-container__code {
  margin-top: var(--spacing-6);
  margin-left: auto;
}

.eye__image {
  position: relative;
  top: 1px;
  right: 2px;
  width: 18px;
  margin-right: var(--spacing-1);
}

@media screen and (max-width: 700px) {
  .sync {
    flex-direction: column;
  }

  .sync-container {
    width: 100%;
  }

  .sync__project-details {
    display: block;
  }

  .sync__project-details > div {
    margin-right: var(--spacing-0);
  }

  .qrcode__container {
    display: block;
  }

  .qrcode-container__code {
    margin-left: var(--spacing-0);
    margin-top: var(--spacing-6);
  }

  .sync__container {
    width: 100%;
  }
}
</style>
